var machineImages = require.context('../../../img/machines', true);

angular.module('octopusApp.shared').service('targetStateMapper', function(octoUtil){
    function calculateTargetIcon(machine){
        var state = machine.HealthStatus;
        if (machine.IsDisabled) {
            state = "Disabled";
        } else if (state !== "Unknown" && state !== "Unavailable" && state !== "Unhealthy") { // Upgrade status shouldn't override these states
            if (machine.Endpoint.TentacleVersionDetails &&
                machine.Endpoint.TentacleVersionDetails.UpgradeSuggested && !machine.Endpoint.TentacleVersionDetails.UpgradeLocked) {
                state = "NeedsUpgrade";
            } else if (!machine.HasLatestCalamari) {
                state = "CalamariNeedsUpgrade";
            }
        }

        var commsStyle = octoUtil.escapeHtml(machine.Endpoint.CommunicationStyle);
        var name = "./Server-" + octoUtil.escapeHtml(state) + "." + commsStyle + ".png";
        return machineImages(name, true);
    }

    return {
        calculateTargetIcon: calculateTargetIcon
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/services/targetStateMapper.js
// module id = 610
// module chunks = 1